import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';

/**
 * Created by vadimdez on 28/01/2018.
 */
let ImgFallbackDirective = /*#__PURE__*/(() => {
  class ImgFallbackDirective {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
      this.loaded = new EventEmitter();
      this.isApplied = false;
      this.ERROR_EVENT_TYPE = 'error';
      this.LOAD_EVENT_TYPE = 'load';
      this.nativeElement = el.nativeElement;
      this.onError = this.onError.bind(this);
      this.onLoad = this.onLoad.bind(this);
      this.addEvents();
    }
    ngOnDestroy() {
      this.removeErrorEvent();
      this.removeOnLoadEvent();
    }
    onError() {
      if (this.nativeElement.getAttribute('src') !== this.imgSrc) {
        this.isApplied = true;
        this.renderer.setAttribute(this.nativeElement, 'src', this.imgSrc);
      } else {
        this.removeOnLoadEvent();
      }
    }
    onLoad() {
      this.loaded.emit(this.isApplied);
    }
    removeErrorEvent() {
      if (this.cancelOnError) {
        this.cancelOnError();
      }
    }
    removeOnLoadEvent() {
      if (this.cancelOnLoad) {
        this.cancelOnLoad();
      }
    }
    addEvents() {
      this.cancelOnError = this.renderer.listen(this.nativeElement, this.ERROR_EVENT_TYPE, this.onError);
      this.cancelOnLoad = this.renderer.listen(this.nativeElement, this.LOAD_EVENT_TYPE, this.onLoad);
    }
  }
  ImgFallbackDirective.ɵfac = function ImgFallbackDirective_Factory(ɵt) {
    return new (ɵt || ImgFallbackDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  ImgFallbackDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ImgFallbackDirective,
    selectors: [["", "src-fallback", ""]],
    inputs: {
      imgSrc: [0, "src-fallback", "imgSrc"]
    },
    outputs: {
      loaded: "loaded"
    }
  });
  return ImgFallbackDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Created by vadimdez on 27/11/2016.
 */
let ImgFallbackModule = /*#__PURE__*/(() => {
  class ImgFallbackModule {}
  ImgFallbackModule.ɵfac = function ImgFallbackModule_Factory(ɵt) {
    return new (ɵt || ImgFallbackModule)();
  };
  ImgFallbackModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ImgFallbackModule
  });
  ImgFallbackModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return ImgFallbackModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Created by Vadym Yatsyuk on 28.01.18
 */

/**
 * Created by Vadym Yatsyuk on 28.01.18
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ImgFallbackDirective, ImgFallbackModule };
